module.exports = "<div class=two-part-allocation-bar-container> <div class=bar-titles ng-if=\"titleLeft || titleRight\"> <div class=\"bar-title-left section-header\">{{titleLeft}}</div> <div class=\"bar-title-right section-header\">{{titleRight}}</div> </div> <div class=bar-outer> <div class=bar-text-left>{{textLeft}}</div> <div class=bar-text-right>{{textRight}}</div> <div class=bar-inner ng-style=\"{width: widthPercent + '%'}\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/two-part-allocation-bar/ws-two-part-allocation-bar.tmpl.html
// module id = 78
// module chunks = 0